import Helper from './Helper';

class MobileHeaderHeight {
  constructor(config = {}) {
    const {
      headerSelector,
    } = config;
    this.header = document.querySelector(headerSelector);
    this.content = document.querySelector('.content');
    this.breakPointMobile = 768;
    
    if(this.header){
      this.bindEvents();
    }
  }

  bindEvents() {
    this.getHeaderHeight();

    window.addEventListener('resize', () => {
      this.getHeaderHeight();
    });
  }

  getHeaderHeight() {
    const vw = window.innerWidth;
    let headerHeight = this.header.clientHeight;
    
    if (vw < this.breakPointMobile) {
      this.content.style.marginTop = headerHeight + "px";
    } else {
      this.content.style.marginTop = null;
    }
  }

}

export default MobileHeaderHeight;
